import { ReactNode } from 'react';
import { usePermissions, Permission } from '@/hooks/use-permissions';
import { AccessDenied } from './AccessDenied';
import { useOrganizationSelector } from '@/hooks/use-organization-selector';

interface RequirePermissionProps {
  permission: Permission | Permission[];
  children: ReactNode;
  fallback?: ReactNode;
  showAccessDenied?: boolean;
  organizationId?: string | null;
}

export function RequirePermission({ 
  permission, 
  children, 
  fallback, 
  showAccessDenied = true,
  organizationId
}: RequirePermissionProps) {
  // Use provided organizationId or get from selector
  const { activeOrganizationId } = useOrganizationSelector();
  const orgId = organizationId ?? activeOrganizationId;
  
  const { hasPermission, hasAnyPermission } = usePermissions({ organizationId: orgId });
  
  const hasRequiredPermission = Array.isArray(permission)
    ? hasAnyPermission(permission)
    : hasPermission(permission);
  
  if (hasRequiredPermission) {
    return <>{children}</>;
  }
  
  if (fallback) {
    return <>{fallback}</>;
  }
  
  if (showAccessDenied) {
    return <AccessDenied permission={permission} />;
  }
  
  return null;
}

